import { render, staticRenderFns } from "./IncidentList.vue?vue&type=template&id=0e166acf&scoped=true"
import script from "./IncidentList.vue?vue&type=script&lang=js"
export * from "./IncidentList.vue?vue&type=script&lang=js"
import style0 from "./IncidentList.vue?vue&type=style&index=0&id=0e166acf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e166acf",
  null
  
)

export default component.exports